import React from "react";
import PropTypes from "prop-types";
import WebinarItem from "./WebinarItem.jsx";
import TablePagination from "components/Pagination/TablePagination";
import Headers from "./Headers.jsx";

function WebinarList({
  groupId,
  webinars,
  navigateToWebinar,
  navigateToFeedback,
  checkedWebinarIds,
  webinar_ids,
  paginationProps,
  onOrderChange,
  query,
  navigateToWebinarsUsers,
  navigateToWebinarsUsersSession,
  navigateToWebinarsUsersNewsletter,
  role,
  navigateToFeedbackEdit,
  navigateToCertificates,
}) {
  return (
    <table>
      <Headers onChange={onOrderChange} value={query.order} />
      {webinars.map((webinar) => (
        <WebinarItem
          role={role}
          webinar={webinar}
          key={webinar.id}
          navigateToWebinar={navigateToWebinar}
          navigateToFeedback={navigateToFeedback}
          navigateToWebinarsUsers={navigateToWebinarsUsers}
          navigateToWebinarsUsersSession={navigateToWebinarsUsersSession}
          navigateToWebinarsUsersNewsletter={navigateToWebinarsUsersNewsletter}
          checkedWebinarIds={checkedWebinarIds}
          webinar_ids={webinar_ids}
          navigateToFeedbackEdit={navigateToFeedbackEdit}
          groupId={groupId}
          navigateToCertificates={navigateToCertificates}
        />
      ))}
      <tr>
        <td colSpan="12">
          <TablePagination {...paginationProps} />
        </td>
      </tr>
    </table>
  );
}

WebinarList.defaultProps = {};

WebinarList.propTypes = {};

export default WebinarList;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/Webinar/List/index.jsx